<template>
    <form
        class="relative flex flex-col gap-y-2 py-2"
        @submit.prevent="validateAccount"
    >
        <label for="email">Email</label>
        <input
            id="email"
            v-model="state.email"
            type="email"
            name="email"
            autocomplete="email"
            placeholder="you@example.com"
            aria-describedby="email-description"
            required
        />
        <p id="email-description" class="sr-only text-sm text-zinc-700">Email address</p>
        <div v-if="state.error.email">
            <p class="text-sm text-red-600">
                {{ state.error.email }}
            </p>
        </div>

        <div class="my-4">
            <button
                type="submit"
                class="button button--primary"
                key="btn-next"
                :disabled="!!state.error.email"
            >
                Next
            </button>
        </div>
    </form>
</template>

<script setup lang="ts">
import { useCheckoutStore } from '@/store/checkout'
import { reactive, watch } from 'vue'
import { isValidEmail } from '@/api/memberships'
import debounce from 'lodash.debounce'

const store = useCheckoutStore()

const state = reactive({
    email: store.$state.email,
    validatedEmail: null as string | null,
    error: {
        email: null as string | null,
    },
})

const validateEmail = debounce((value) => {
    if (isValidEmail(value)) {
        state.error.email = null
        state.email = value
    } else {
        state.error.email = 'Please enter a valid email address'
        state.validatedEmail = null
    }
}, 500)

watch(() => state.email, validateEmail)

const nextStep = () => {
    store.$patch({
        accountValidated: true,
        steps: {
            createAccount: {
                complete: true,
                open: false,
            },
            selectEquipment: {
                open: true,
            },
        },
    })
}

const validateAccount = async() => {
    if (!isValidEmail(state.email)) {
        state.error.email = 'Please enter a valid email address'
        return
    } else {
        state.error.email = null
    }

    store.$patch({
        email: state.email,
    })
    state.validatedEmail = state.email
    nextStep()
}
</script>
